// extracted by mini-css-extract-plugin
export default {"block":"ai","select":"bi","empty":"ci","open":"di","error":"ei","options":"fi","selectActive":"gi","ornament":"hi"};